import { AuditCard } from "@/features/Audit/AuditCard";
import i18n from "@/i18n";
import { useParams } from "react-router-dom";
import { M2StaticDatumsEditCard } from "./edit_card";
import { Clients } from "@/lib/clients";
import { Tables } from "@/gen/tableNames/tables";

const client = Clients.M2;
const table_name = Tables.M2_STATIC_DATA;

export const M2StaticDatumsEdit = () => {
  const { id } = useParams<{ id: string }>();

  if (!id) {
    return <div>{i18n.t("errors.invalid_id")}</div>;
  }

  return (
    <div className="bg-gray-50 relative">
      <div className="flex flex-col gap-10 p-10">
        <M2StaticDatumsEditCard
          id={Number(id)}
          client={client}
          table_name={table_name}
        />
        <AuditCard
          id={Number(id)}
          client={client}
          audit_table_name={table_name}
        />
      </div>
    </div>
  );
};
